// eslint-disable-next-line import/no-unresolved
import { localeSelector } from 'app/store/selectors/general';
import { addSeconds } from 'date-fns';
import { createSelector } from 'reselect';
import { getUTCDate } from 'app/functions';
import {
    getCityCountryCode,
    getLocationName,
    getCityById,
    groupResultsByContinent,
} from 'app/functions/location';

export const autocompleteDepartureCurrentResults = state => (
    state.location.autocomplete.departure.current
);
export const autocompleteArrivalCurrentResults = state => (
    state.location.autocomplete.arrival.current
);
export const autocompleteDepartureDefaultResults = state => (
    state.location.autocomplete.departure.default
);
export const autocompleteArrivalDefaultResults = state => (
    state.location.autocomplete.arrival.default
);
export const autocompleteDepartureLoadingSelector = state => (
    state.location.autocomplete.departure.loading
);
export const autocompleteArrivalLoadingSelector = state => (
    state.location.autocomplete.arrival.loading
);

export const errorDepartureSelector = state => state.location.autocomplete.departure.error;
export const errorArrivalSelector = state => state.location.autocomplete.arrival.error;

export const citiesDetailsSelector = state => state.location.citiesDetails;
export const cityTrainPairsSelector = state => state.location.cityTrainPairs;

// Not to use these selectors outside because they can return uuid or legacyId.
// @todo That should be normalized in next steps.
const departureCityIdSelector = state => state.location.departure.id;
const arrivalCityIdSelector = state => state.location.arrival.id;

export const autocompleteDepartureCurrentByContinentSelector = createSelector(
    autocompleteDepartureCurrentResults,
    groupResultsByContinent,
);

export const autocompleteArrivalCurrentByContinentSelector = createSelector(
    autocompleteArrivalCurrentResults,
    groupResultsByContinent,
);

export const autocompleteDepartureDefaultByContinentSelector = createSelector(
    autocompleteDepartureDefaultResults,
    groupResultsByContinent,
);

export const autocompleteArrivalDefaultByContinentSelector = createSelector(
    autocompleteArrivalDefaultResults,
    groupResultsByContinent,
);

export const currentCitiesDetailsSelector = createSelector(
    citiesDetailsSelector,
    localeSelector,
    (cities, locale) => ((locale in cities) ? cities[locale] : {}),
);

export const departureCitySelector = createSelector(
    departureCityIdSelector,
    currentCitiesDetailsSelector,
    (...args) => getCityById(...args),
);

export const arrivalCitySelector = createSelector(
    arrivalCityIdSelector,
    currentCitiesDetailsSelector,
    (...args) => getCityById(...args),
);

export const currentDateAtDepartureCitySelector = createSelector(
    departureCitySelector,
    (departureCity) => {
        const offset = departureCity.timezoneOffset || 0;

        return addSeconds(getUTCDate(), offset);
    },
);

export const departureCountryCodeSelector = createSelector(
    departureCitySelector,
    (...args) => getCityCountryCode(...args),
);

export const arrivalCountryCodeSelector = createSelector(
    arrivalCitySelector,
    (...args) => getCityCountryCode(...args),
);

export const selectedDepartureNameSelector = createSelector(
    departureCitySelector,
    (...args) => getLocationName(...args),
);

export const selectedArrivalNameSelector = createSelector(
    arrivalCitySelector,
    (...args) => getLocationName(...args),
);

export const selectedRouteNameSelector = createSelector(
    selectedDepartureNameSelector,
    selectedArrivalNameSelector,
    (departureName, arrivalName) => (`${departureName}-${arrivalName}`),
);
